import React from "react"
/*VIEW*/
import Img from "components/Img"

/*Ui*/
import Cont from "components/ui/Cont"
import OfferSlider, {
    OfferSlide,
    OfferSliderText,
} from "components/ui/OfferSlider"

import "./style"
import "./media"

/*HELPERS*/
import { Helpers } from "api"
import { IsArray } from "helpers/ValueTests"

const ContOffer = ({ id, value }) => {
    return (
        value &&
        IsArray(value) &&
        value.length > 0 && (
            <Cont id={`block-${id}`} className="cont-offer">
                <OfferSlider>
                    {value.map((item) => (
                        <OfferSlide
                            key={item.id}
                            image={
                                <Img
                                    src={`${Helpers.GetImage(
                                        item.photo[0],
                                        "full"
                                    )}`}
                                    externals
                                    div
                                />
                            }
                        >
                            <OfferSliderText className="show-left">
                                <h1>{item.title}</h1>

                                <p>{item.lead}</p>
                            </OfferSliderText>
                        </OfferSlide>
                    ))}
                </OfferSlider>
            </Cont>
        )
    )
}

export default ContOffer
